import { useEffect, useState } from 'react';
import { Alert, Stack, Typography } from '@mui/joy';
import { useQuery } from '@tanstack/react-query';
import api from '../../lib/api';
import { communicationError } from '../../lib/communicationRequests';

export function SMSMessagePreview({ toNumber, fromNumber, body, purpose = 'conversation' }: {
  toNumber: string; fromNumber?: string; body: string; purpose?: string;
}) {
  const [draft, setDraft] = useState({ toNumber, fromNumber, body, purpose });
  useEffect(() => {
    const timer = setTimeout(() => setDraft({ toNumber, fromNumber, body, purpose }), 450);
    return () => clearTimeout(timer);
  }, [toNumber, fromNumber, body, purpose]);
  const preview = useQuery({ queryKey: ['sms-preview', draft], enabled: !!draft.toNumber && !!draft.body.trim(), retry: false,
    queryFn: async () => (await api.post<{ body: string; segments: number; estimated_cost: string; can_fund: boolean; from_number: string }>('/api/inbox/sms/preview/', {
      to_number: draft.toNumber, from_number: draft.fromNumber, body: draft.body, purpose: draft.purpose,
    })).data });
  if (!body.trim()) return <Typography level="body-xs">Business identification and STOP instructions are added to every message. Recipient permission is checked before sending.</Typography>;
  if (preview.isError) return <Alert color="warning">{communicationError(preview.error)} Manage registration and recipient permission in Settings → Communications.</Alert>;
  return <Stack spacing={0.5}>
    {preview.isFetching && <Typography level="body-xs">Checking sender, permission and estimated cost…</Typography>}
    {preview.data && <><Typography level="body-xs">From {preview.data.from_number} · {preview.data.segments} estimated segment{preview.data.segments === 1 ? '' : 's'} · ${Number(preview.data.estimated_cost).toFixed(4)}</Typography>
      <Typography level="body-sm" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', bgcolor: 'background.level1', p: 1, borderRadius: 'sm' }}>{preview.data.body}</Typography>
      {!preview.data.can_fund && <Alert color="warning">Add funds in Settings → Billing before sending.</Alert>}</>}
  </Stack>;
}
